import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=6938311d&scoped=true&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=6938311d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6938311d",
  null
  
)

export default component.exports